import {Component} from 'preact';
import {Query} from 'react-apollo';
import prop from 'ramda/src/prop';
import map from 'ramda/src/map';
import pathOr from 'ramda/src/pathOr';
import {GetOrders} from '@services/OrdersService/query.graphql';

const getSKu = map( prop( 'sku' ) );

class PastPurchases extends Component {
    mapSkusToPurchaseDate ( orders ) {
        return orders.reduce( ( acc, next ) => {
            const {orderDate, orderNumber} = next;
            const skus = new Set( getSKu( acc ) );
            // flatten Product list to remove duplicate SKUs keeping first instance in
            next.lineItems.forEach( item => {
                // filter null items (marketing materials?s)
                if ( !item.product ) {
                    return;
                }

                if ( !skus.has( item.product.sku ) ) {
                    acc.push( {...item.product, orderDate, orderNumber} );
                }
            } );

            return acc;
        }, [] );
    }

    render ( {brandId, children} ) {
        const isLogged = pathOr( false, ['user', 'isLogged'], this.context );
        const isEcommerceSite = pathOr( false, ['conf', 'isEcommerceSite'], this.context );

        if ( !isLogged || !isEcommerceSite ) {
            return;
        }

        return (
            <Query
                query={GetOrders}
                variables={{numberOfDays: 365, numberOfRows: 50}}>
                {( {data, loading} ) => {
                    let skuList = [];

                    console.log( 'data.orders', brandId, data.orders )
                    if ( data && data.orders ) {
                        skuList = this.mapSkusToPurchaseDate( data.orders ).filter( i => i.brandId == brandId );
                    }

                    return children( {loading, skuList} );
                }}
            </Query>
        );
    }
}

export default PastPurchases;
